import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../services/api.service';
import { ApiUrl } from '../services/apiUrl';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-door-status',
  templateUrl: './door-status.component.html',
  styleUrls: ['./door-status.component.scss'],
})
export class DoorStatusComponent implements OnInit {
  flag: any = [
    { name: 'Red', value: "false" },
    { name: 'Green', value: "true"},
  ];
  statusFlag: any =null;
  timeout: any = null;
  storeList: any;
  page: any = 1;
  total: any = 0;
  pageSize = 10;
  selectedPage: any;
  word: any = '';
  count: number = 5;
  startDate: any = '';
  endDate: any = '';
  date: any;
  managerId = localStorage.getItem('managerId');
  role: any = localStorage.getItem('role');
  imageurl = environment.imageUrl;
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private service: ApiService
  ) {}

  ngOnInit() {
    this.showList();
  }
  showList() {
    this.spinner.show();
    if (this.role == 'manager' && this.managerId) {
      this.service
        .getRequest(
          `${ApiUrl.storeDoorStatusById}${this.managerId}` +
            `?page=` +
            this.page +
            `&word=` +
            this.word +
            `&statusFlag=` +
            this.statusFlag
        )
        .subscribe(
          (res: any) => {
            this.storeList = res.response?.data?.storesData;
            this.total = res.response?.data?.storeCount;
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
          }
        );
    } else {
      this.service
        .getRequest(
          ApiUrl.storeDoorStatus +
            `?page=` +
            this.page +
            `&word=` +
            this.word +
            `&statusFlag=` +
            this.statusFlag
        )
        .subscribe(
          (res: any) => {
            this.storeList = res.response?.data?.storesData;
            this.total = res.response?.data?.storeCount;
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
          }
        );
    }
  }

  clearDate() {
    this.startDate = '';
    this.endDate = '';
    this.date = '';
    this.showList();
  }

  updateRangeDate(event: any) {
    if (event.start && event.end) {
      this.startDate = moment(event.start).startOf('day').format('YYYY-MM-DD');
      this.endDate = moment(event.end).endOf('day').format('YYYY-MM-DD');
      this.showList();
      // if (this.role == 1) {
      //   this.getAllLeads(this.pageNumber, this.pageSize, this.search, this.startDate, this.endDate, this.status);
      // } else {
      //   this.assignedLeadOfUser()
      // }
    }
  }
  pageChanged(event: any) {
    this.page = event;
    this.selectedPage = event;
    this.showList();
  }
  onFilterKeySearch() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.showList();
    }, 1000);
  }
}
